export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'https://integ.lili.co/lili/api/'
    : '/lili/api/'

class HttpService {
  get = (endpoint, data = null, header, shouldAllowCookie = null) => {
    return this.ajax(endpoint, data, header, 'GET', shouldAllowCookie)
  }
  post = (endpoint, data = null, header, shouldAllowCookie = null) => {
    return this.ajax(endpoint, data, header, 'POST', shouldAllowCookie)
  }
  put = (endpoint, data = null, header, shouldAllowCookie = null) => {
    return this.ajax(endpoint, data, header, 'PUT', shouldAllowCookie)
  }
  delete = (endpoint, data = null, header, shouldAllowCookie = null) => {
    return this.ajax(endpoint, data, header, 'DELETE', shouldAllowCookie)
  }
  ajax = async (endpoint, data, header, method, shouldAllowCookie) => {
    try {
      let response
      if (method.toLowerCase() === 'get') {
        response = await fetch(`${BASE_URL}${endpoint}`, {
          method,
          timeout: 90000,
          credentials: shouldAllowCookie ? 'same-origin' : 'omit',
          keepalive: true,
          headers: header
            ? {
                [header.headerName]: header.headerValue,
                'Content-Type': 'application/json',
              }
            : {
                'Content-Type': 'application/json',
              },
        })
      } else {
        response = await fetch(`${BASE_URL}${endpoint}`, {
          credentials: shouldAllowCookie ? 'same-origin' : 'omit',
          keepalive: true,
          timeout: 90000,
          body: JSON.stringify(data),
          method,
          headers: header
            ? {
                [header.headerName]: header.headerValue,
                'Content-Type': 'application/json',
              }
            : {
                'Content-Type': 'application/json',
              },
        })
      }

      if (!response.ok) {
        throw response
      }

      try {
        return await response.json()
      } catch (e) {
        return null
      }
    } catch (error) {
      let parsedData
      try {
        parsedData = await error.json()
      } catch (e) {
        parsedData = null
      }

      const errorObj = { rawError: error, data: parsedData }
      throw errorObj
    }
  }
}

const HTTP = new HttpService()
Object.freeze(HTTP)
export default HTTP



// WEBPACK FOOTER //
// ./src/services/HttpService.js